import { useTheme } from "@/utils/theme-context";
import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/utils/auth-context";
import EditIcon from "./UI/EditIcon";
import { useVideos } from "@/utils/video-context";
import PlayIcon from "./UI/PlayIcon";

import { auth, db } from "@/firebase/firebaseConfig";
import { doc, updateDoc } from "firebase/firestore";
import LessonThumbnail from "./UI/LessonThumbnail";
import logoPng from "@img/preview-logo.webp";

import QuestionaryLoader from "@components/UI/QuestionaryLoader.jsx";
import { Alert } from "antd";
import InvestorModal from "./InvestorModal";

const Lessons = ({ courseType }) => {
  const { fetchVideos } = useVideos();

  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const { theme } = useTheme();
  const [isLessonCompleted, setIsLessonCompleted] = useState({});
  const adminId = "DyNgoxrjL3RtmQZyeeZ60maTo0F2";
  const { user, isVerified } = useAuth();
  const [maxModules, setMaxModules] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      if (user === null || user === undefined) {
        console.log("Нет пользователя, пропускаем загрузку");
        setIsLoading(true);
        return;
      }

      console.log("Загрузка данных...");
      setIsLoading(true);
      await fetchVideos(
        setData,
        courseType,
        setMaxModules,
        setIsLessonCompleted,
        maxModules
      );
      setIsLoading(false);
    };

    loadData();
  }, [user, courseType, fetchVideos, maxModules]);

  if (isLoading) {
    return (
      <QuestionaryLoader text={`Идет загрузка уроков`}></QuestionaryLoader>
    );
  }

  const handleOpenLesson = (lesson, e) => {
    if (!isVerified && courseType !== "trialLessons") {
      setShowModal(true);
      return;
    }

    const userId = auth.currentUser?.uid;
    const lessonUID = e.id + lesson.id;

    const markLessonAsCompleted = async () => {
      const userRef = doc(db, "users", userId);
      await updateDoc(userRef, {
        [`completedLessons.${lessonUID}`]: true,
      });

      setIsLessonCompleted((prevState) => ({
        ...prevState,
        [`${e.id}${lesson.id}`]: true,
      }));
    };

    markLessonAsCompleted();

    navigate(`${lesson.id}`, {
      relative: "path",
      state: {
        key: lesson.id,
        id: lesson.id,
        lessonTitle: lesson.title,
        lessonUrl: lesson.videoURL,
        secondUrl: lesson.url,
        lessonContent: lesson.content,
        haveFile: lesson.haveFile,
        images: lesson.images,
        allLessons: data,
        category: lesson.category,
        courseType: courseType,
        moduleId: e.id,
      },
    });
  };

  return (
    <div className={`layout`}>
      {showModal && (
        <InvestorModal
          text="Для просмотра этого урока требуется подтверждённый аккаунт."
          closeModal={() => setShowModal(false)}
        />
      )}
      <Alert
        message="Мы занимаемся улучшайзингом :)"
        description={
          <div>
            <p>
              <strong>Новые уроки про рекламу!</strong>
            </p>
            <p>
              Смотрите разбор рекламы с учениками:{" "}
              <strong>разбор ошибок в рекламном кабинете</strong> и первые
              продажи. Смотрите в модуле 8, уроки 9 и 10.
            </p>
            <p>
              <strong>У Кого НЕ ПРИХОДИЛ СМС-КОД</strong> — мы добавили новый
              урок!
            </p>
            <p>
              Смотрите урок{" "}
              <strong>«Покупка виртуального номера» в модуле 2.</strong>
            </p>
          </div>
        }
        type="success"
        showIcon
      />
      {data.map((e) => (
        <div className="lessons" key={e.id}>
          <div className="lessons__title">
            <p>{e.title}</p>
            <span className={`lessons__subtitle lessons__subtitle--${theme}`}>
              {e.videos.length} видео
            </span>
            {user?.uid === adminId && (
              <NavLink
                key={e.id}
                to="/edit-module"
                state={{
                  moduleId: e.id,
                  category: e.category,
                  isVisible: e.isVisible,
                  title: e.title,
                }}
                className="layout__adminBtn"
              >
                <EditIcon color={"red"} />
              </NavLink>
            )}
          </div>
          <div className="lessons-links">
            {e.videos &&
              e.videos?.map((lesson, index) => (
                <div
                  className="lessons-link-box"
                  key={lesson.id}
                  onClick={() => handleOpenLesson(lesson, e)}
                >
                  <div className="video-container">
                    {lesson.videoURL ? (
                      <LessonThumbnail
                        videoId={lesson.videoURL}
                      ></LessonThumbnail>
                    ) : (
                      <img
                        className="lessons-links-item lessons-links-item--thumbnail "
                        src={logoPng}
                        alt=""
                      />
                    )}
                    {lesson.videoURL && (
                      <PlayIcon
                        isDone={isLessonCompleted[`${e.id}${lesson.id}`]}
                      />
                    )}
                  </div>
                  <div className="lessons-links-text">
                    <p className="lessons-links-item__index">
                      {`Урок ${index + 1}`}
                    </p>
                    <p className="lessons-links-item__title">{lesson.title} </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Lessons;
